import { PortfolioWorks } from '../PortfolioWorks';
import {PortfolioContent,PortfolioContainer} from './styles';

export function Portfolio(){
    return (
        <PortfolioContent id="portfolio">
            <PortfolioContainer>
                <h2>Portfolio</h2>
                <p>Alguns dos projetos que fiz recentemente</p>
                <PortfolioWorks/>
            </PortfolioContainer>
        </PortfolioContent>
    )
}